import { useEffect, useState } from 'react'
import Header from '../../components/BasicComponent/Header'
import HeaderMiniApp from '../../components/BasicComponent/HeaderMiniApp'
import { useAppParamsContext } from '../../context/AppParamsContext'
import Banner from './components/Banner'
import BrandLoading from './components/BrandLoading'
import ViolationLookup from './components/ViolationLookup'
import './index.scss'

export default function TrafficViolationsLookup() {
  const { isEmbeddedView, isHeaderMiniApp, showBannerInEmbeddedView } = useAppParamsContext()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <BrandLoading />
  }

  return (
    <div className="TrafficViolationsLookup_page">
      {isEmbeddedView && !isHeaderMiniApp ? <></> : isHeaderMiniApp ? <HeaderMiniApp /> : <Header />}

      <main className="TrafficViolationsLookup_main">
        {(!isEmbeddedView || showBannerInEmbeddedView) && <Banner isEmbeddedView={isEmbeddedView} />}

        <ViolationLookup />
      </main>
    </div>
  )
}
